import React from "react";
import { useHistory } from "react-router";
import { Routes } from "../../root/routes";
import { WorkflowSetupPageWrapper } from "./WorkflowSetupPageWrapper";

type PortabilityInstructionsPageProps = {
  embedded?: boolean;
};

export const PortabilityInstructionsPage = ({
  embedded = false,
}: PortabilityInstructionsPageProps = {}) => {
  const history = useHistory();
  const pageContent = <></>;

  if (embedded) {
    return pageContent;
  }

  return (
    <WorkflowSetupPageWrapper
      selectedTabKey="portability-request"
      nextOnClick={() => history.push(Routes.organization.requestHandling.requestToObjection)}
      nextDisabled={false}
      nextContent="Next"
    >
      {pageContent}
    </WorkflowSetupPageWrapper>
  );
};
